// src/app/store/user/user.actions.ts
import { createAction, props } from '@ngrx/store';
import { User } from '../../core/models/user.model';
import { PaginationRequest } from '@/app/core/models/pagination.model';

// Load Users
export const loadUsers = createAction('[Users] Load Users',
    props<{ pagination: PaginationRequest }>()
);
export const loadUsersSuccess = createAction(
    '[Users] Load Users Success',
    props<{ users: User[], total: number }>() // Add total
);
export const loadUsersFailure = createAction(
    '[Users] Load Users Failure',
    props<{ error: string }>()
);

// Add User
export const addUser = createAction(
    '[Users] Add User',
    props<{ user: Omit<User, 'id'> }>() // User data without ID
);
export const addUserSuccess = createAction(
    '[Users] Add User Success',
    props<{ user: User }>() // Server returns user with generated ID
);
export const addUserFailure = createAction(
    '[Users] Add User Failure',
    props<{ error: string }>()
);

// Update User
export const updateUser = createAction(
    '[Users] Update User',
    props<{ user: User }>()
);
export const updateUserSuccess = createAction(
    '[Users] Update User Success',
    props<{ user: User }>()
);
export const updateUserFailure = createAction(
    '[Users] Update User Failure',
    props<{ error: string }>()
);

// Delete User
export const deleteUser = createAction(
    '[Users] Delete User',
    props<{ id: string | number }>()
);
export const deleteUserSuccess = createAction(
    '[Users] Delete User Success',
    props<{ id: string | number }>()
);
export const deleteUserFailure = createAction(
    '[Users] Delete User Failure',
    props<{ error: string }>()
);